import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PopupBenefitComponent } from './shared/popup-benefit.component';

@Component({
  template: `
    <div class="popup">
      <div class="popup__background">
        <div class="popup__heading color-go-green-heading">Go Paperless, Go&nbsp;Green</div>
        <div class="popup__subheading color-go-green-heading">Receive your mortgage documents electronically</div>

        <div class="benefit-container">
          <app-popup-benefit
            src="/media/static/app/browser/assets/popups/go-green/fast.svg"
            heading="Fast"
            text="Receive documents faster in a secure online format"
          />

          <app-popup-benefit
            src="/media/static/app/browser/assets/popups/go-green/convenient.svg"
            heading="Convenient"
            text="View documents online anytime"
          />
          <app-popup-benefit
            src="/media/static/app/browser/assets/popups/go-green/green.svg"
            heading="Green"
            text="Reduce the need for paper and shrink your carbon footprint"
          />
          <app-popup-benefit
            src="/media/static/app/browser/assets/popups/go-green/free.svg"
            heading="Free"
            text="There is no cost to receive documents electronically"
          />
        </div>
      </div>
      <div class="popup__bottom-container">
        <a class="btn btn-go-green" href="/loanmanager/go-green/">Click Here to Go Green</a>
        <p>
          <a href (click)="close($event)">Not at this time, I prefer to receive paper documents via mail</a>
        </p>
      </div>
    </div>
  `,
  styles: [
    `
      .popup {
        color: white;
      }

      app-popup-benefit {
        padding: 15px;
      }

      .popup__background {
        background-image: url('/media/static/app/browser/assets/popups/go-green/background.jpg');
        background-position: 50% 29%;
      }

      .color-go-green-heading {
        color: #2b6550;
      }

      .benefit-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, 50%);

        @media screen and (min-width: 600px) {
          grid-template-columns: repeat(auto-fill, 25%);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PopupBenefitComponent],
})
export class GoGreenPopupComponent {
  private dialogRef = inject<MatDialogRef<GoGreenPopupComponent>>(MatDialogRef);

  close(event: MouseEvent) {
    event.preventDefault();
    this.dialogRef.close();
  }
}
